import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/jd_logo.png";
import { useInstall } from "@/contexts/InstallContext";
import { Download } from "lucide-react";

export default function Footer() {
  const { canInstall, promptInstall } = useInstall();
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <img src={logo} className="h-16 w-24" alt="Job Dew" />
          </div>
          <p className="mt-3 text-sm text-slate-600 max-w-sm">
            India's free, city-wise job portal — bringing local shop owners, businesses and seekers together.
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-slate-900 mb-3">For Seekers</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/jobs"     className="hover:text-[#1D6FF2]">Browse Jobs</Link></li>
            <li><Link to="/register" className="hover:text-[#1D6FF2]">Create Account</Link></li>
            <li><Link to="/blog"     className="hover:text-[#1D6FF2]">Career Blog</Link></li>
            {canInstall && (
              <li>
                <button type="button" onClick={promptInstall} className="hover:text-[#1D6FF2] inline-flex items-center gap-1">
                  <Download className="w-3.5 h-3.5" /> Install App
                </button>
              </li>
            )}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-slate-900 mb-3">For Employers</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/register" className="hover:text-[#1D6FF2]">Post a Job — Free</Link></li>
            <li><Link to="/about"    className="hover:text-[#1D6FF2]">About</Link></li>
            <li><Link to="/contact"  className="hover:text-[#1D6FF2]">Contact Us</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200 py-4 text-xs text-slate-500">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 text-center">
    <p>
      © {new Date().getFullYear()} Job Dew. All rights reserved.
      {" · "}
      <Link to="/blog" className="hover:text-[#1D6FF2]">Blog</Link>
    </p>
    <p>
      Developed and managed by{" "}
      <a
        href="https://x7ittechnologies.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold text-slate-700 hover:text-[#1D6FF2] transition-colors"
      >
        X7 IT Technologies
      </a>
    </p>
  </div>
</div>
    </footer>
  );
}